import axiosInstance from "../tokenInterceptor/AxiosInstance";

export class InviteeService {
  constructor() {
    this.step1Api = "invitees/register/step1";
    this.step2Api = "invitees/register/step2"; // /{inviteeId}
    this.createOrderApi = "payment/create-order";
    this.completePaymentApi = "invitees/complete-payment";
  }


  // ============================================================
  // STEP 1
  // POST /invitees/register/step1?euid=XXX
  // Body → InviteeBasicDto
  // ============================================================
  async step1(euid, dto) {
    try {
      const response = await axiosInstance.post(
        this.step1Api,
        dto,
        {
          params: { euid },                 // 🔑 IMPORTANT
          validateStatus: (status) => status < 500
        }
      );

      return response;
    } catch (error) {
      console.error("Step1 Error:", error);
      throw error;
    }
  }

  // ============================================================
  // STEP 2
  // POST /invitees/register/step2/{inviteeId}?euid=XXX
  // Body → InviteeDto
  // ============================================================
  async step2(euid, inviteeId, dto) {
    const url = `${this.step2Api}/${inviteeId}`;

    try {
      const response = await axiosInstance.post(
        url,
        dto,
        {
          params: { euid },                 // 🔑 IMPORTANT
          validateStatus: (status) => status < 500
        }
      );

      return response;
    } catch (error) {
      console.error("Step2 Error:", error);
      throw error;
    }
  }

  // ============================================================
  // OPTIONAL HELPER — BUILD InviteeDto
  // ============================================================
  submitStep2(euid, inviteeId, profile = {}, payment = {}, token) {
    const dto = {
      name: profile.name || "",
      email: profile.email || "",
      phone: profile.phone || "",

      companyName: profile.companyName || "",
      designation: profile.designation || "",
      industry: profile.industry || "",
      function: profile.function || "",
      role: profile.role || "",
      linkedInProfile: profile.linkedInProfile || "",
      city: profile.city || "",
      state: profile.state || "",
      areaOfInterest: Array.isArray(profile.areaOfInterest)
        ? profile.areaOfInterest
        : [],

      profilePhoto: profile.profilePhoto || null,
      idProof: profile.idProof || null,

      // payment
      isPaymentSuccessful: !!payment.isPaymentSuccessful,
      transactionId: payment.transactionId || null
    };

    return this.step2(euid, inviteeId, dto, token);
  }

  // ============================================================
  // PAYMENT
  // ============================================================
  createPaymentOrder(paymentRequest) {
    return axiosInstance.post(this.createOrderApi, paymentRequest, {
      validateStatus: (status) => status < 500
    });
  }

  completePaymentRegistration(data, token) {
    return axiosInstance.post(this.completePaymentApi, data, {
      headers: this._authHeader(token),
      validateStatus: (status) => status < 500
    });
  }
}

export default InviteeService;
